import React from "react";
import Plate from "./plate";
import { CdsContentPanel } from "clayco-component-library/lib";
import * as Icon from "react-bootstrap-icons";
import Spinner from "../../skills-experience/shared/spinner"; // Import Spinner
import "../../../styles/license-plates.scss";

const Plates = ({ setShowModal, setSelectedPlate, deletePlate, licensePlates, loading, error }) => {
    function editPlate(plate) {
        setSelectedPlate(plate);
        setShowModal(true);
    }

    function addPlate() {
        setSelectedPlate({});
        setShowModal(true);
    }

    return (
        <CdsContentPanel
            title={'License Plates'}
            description={'Maximum of 2 License Plates Allowed'}
            primaryButtonHandler={addPlate}
            primaryButtonText={'Add a License Plate'}
            disablePrimaryButton={licensePlates?.length > 1 || loading}
            primaryButtonSubmits={false}
            collapsible={false}
            collapsed={false}
        >
            {/* Display loading spinner */}
            {loading ? (
                <Spinner show={true} text={"Loading license plates..."} />
            ) : error ? (
                /* Display error state */
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '150px',
                    textAlign: 'center',
                    color: '#B00020',
                    backgroundColor: '#FFF4F4',
                    borderRadius: '4px',
                    padding: '1rem',
                    fontWeight: '500'
                }}>
                    {error}
                </div>
            ) : (
                /* Display license plates if no loading or error */
                <>
                    {Array.isArray(licensePlates) && licensePlates.length > 0 ? (
                        <div className="license-plates">
                            <div className="row d-flex d-xl-flex title">
                                <div className="col col-6 col-xl-6 mb-0 pb-0">
                                    <p>Plate Number</p>
                                </div>
                                <div className="col col-6 col-xl-6 mb-0 pb-0">
                                    <p>Actions</p>
                                </div>
                            </div>
                            {licensePlates.map((plate, idx) => (
                                <div
                                    key={`degree-${idx}`}
                                    className="row data mb-3 mb-xl-0"
                                >
                                    <div className="col col-6 col-xl-6 d-block pt-2">
                                        <p style={{ textAlign: 'start' }}>{plate.plateNumber}</p>
                                    </div>
                                    <div
                                        className="col col-6 col-xl-6 d-block pt-2"
                                        style={{ textAlign: 'start' }}
                                    >
                                        <Icon.Pencil
                                            color="#da291c"
                                            className="ms-3 icon"
                                            key={`edit-${plate.id}`}
                                            onClick={() => editPlate(plate)}
                                            role="button"
                                        />
                                        <Icon.TrashFill
                                            color="#da291c"
                                            className="ms-3 icon"
                                            key={`delete-${plate.id}`}
                                            onClick={() => deletePlate(plate)}
                                            role="button"
                                        />
                                    </div>
                                </div>
                            ))}
                            {licensePlates.length > 1 && (
                                <div className="mt-2" style={{ textAlign: 'end' }}>
                                    <small className="text-muted mt-2">
                                        Have more plates to add? Email
                                    </small>
                                    <small className="ms-1">
                                        <a href="mailto:Facilities@Claycorp.com">
                                            Facilities@Claycorp.com
                                        </a>
                                    </small>
                                </div>
                            )}
                        </div>
                    ) : (
                        /* Display fallback message if no plates */
                        <div>You have not entered any license plates yet.</div>
                    )}
                </>
            )}
        </CdsContentPanel>
    );
};

export default Plates;
